import { render, staticRenderFns } from "./RespMascList.vue?vue&type=template&id=ec5c40bc&scoped=true&"
import script from "./RespMascList.vue?vue&type=script&lang=js&"
export * from "./RespMascList.vue?vue&type=script&lang=js&"
import style0 from "./RespMascList.vue?vue&type=style&index=0&id=ec5c40bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5c40bc",
  null
  
)

export default component.exports